import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const getMenuPaperStyle = (theme) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: capitalDesignTokens.foundations.units.unitHalf,
  boxShadow: "1px 2px 7px 0px rgba(19, 21, 23, 0.10)",
  marginTop: 2
});
const MuiMenu = {
  defaultProps: {},
  styleOverrides: {
    // Styles applied to Paper component within Menu component
    paper: ({ theme }) => ({
      ...getMenuPaperStyle(theme)
    })
  }
};
export {
  MuiMenu,
  getMenuPaperStyle
};
//# sourceMappingURL=MuiMenu.js.map
